"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFixLinkConsistencyChangesets = exports.checkLinkConsistency = void 0;
const commands_1 = require("../commands");
const engine_1 = require("../engine");
const store_1 = require("../exports/store");
const selectors_1 = require("../exports/store/selectors");
const types_1 = require("../types");
const field_types_1 = require("../types/field_types");
function checkLinkConsistency(state, _loadedForeignDstId) {
    var _a, _b, _c, _d;
    const datasheet = (0, selectors_1.getDatasheet)(state);
    if (!datasheet || datasheet.isPartOfData) {
        return;
    }
    const { snapshot, id: mainDstId, name: mainDstName } = datasheet;
    // the check of data consistency
    // datasheet is the only object that should be attention
    // if if all the permission of datasheet is ok, no need to check more
    if (!((_a = datasheet.permissions) === null || _a === void 0 ? void 0 : _a.editable)) {
        // when the permission of datasheet is not ok, then check other factors
        if (!state.pageParams.mirrorId) {
            return;
        }
        const mirror = (0, selectors_1.getMirror)(state, state.pageParams.mirrorId);
        if ((mirror === null || mirror === void 0 ? void 0 : mirror.sourceInfo.datasheetId) !== mainDstId) {
            return;
        }
        // mirror's editable permission can go through the original datasheet's permission
        if (!(mirror === null || mirror === void 0 ? void 0 : mirror.permissions.editable)) {
            return;
        }
    }
    const { recordMap } = snapshot;
    const fieldMap = snapshot.meta.fieldMap;
    /** does not include self-linking fields */
    const linkFieldIds = [];
    const linkedForeignDstIds = new Set();
    for (const fieldId in fieldMap) {
        if (fieldMap[fieldId].type === field_types_1.FieldType.Link) {
            const prop = fieldMap[fieldId].property;
            if (prop.foreignDatasheetId !== mainDstId && prop.brotherFieldId) {
                linkFieldIds.push(fieldId);
                linkedForeignDstIds.add(prop.foreignDatasheetId);
            }
        }
    }
    // no valid link fields, don't check consistency
    if (!linkFieldIds.length) {
        return;
    }
    // Loaded foreign datasheet is not directly linked, ignore.
    // if (!linkedForeignDstIds.has(loadedForeignDstId)) {
    //   return;
    // }
    // Only when all linked datasheets are fully loaded then link consistency is checked.
    for (const dstId of linkedForeignDstIds) {
        const foreignDst = (0, selectors_1.getDatasheet)(state, dstId);
        if (!foreignDst) {
            return;
        }
        if (foreignDst.isPartOfData) {
            return;
        }
        if (!((_b = foreignDst.permissions) === null || _b === void 0 ? void 0 : _b.editable)) {
            return;
        }
    }
    const errorRecordIds = new Map();
    const addRecordId = (type, dstId, recordId, fieldId, recordIdInCell) => {
        let data = errorRecordIds.get(dstId);
        if (!data) {
            data = new Map();
            errorRecordIds.set(dstId, data);
        }
        const cellId = recordId + ':' + fieldId;
        let recordIds = data.get(cellId);
        if (!recordIds) {
            recordIds = {};
            data.set(cellId, recordIds);
        }
        if (recordIds[type]) {
            recordIds[type].add(recordIdInCell);
        }
        else {
            recordIds[type] = new Set([recordIdInCell]);
        }
    };
    const addMissingRecordId = (dstId, recordId, fieldId, missingRecordId) => addRecordId('missing', dstId, recordId, fieldId, missingRecordId);
    const addRedundantRecordId = (dstId, recordId, fieldId, redundantRecordId) => addRecordId('redundant', dstId, recordId, fieldId, redundantRecordId);
    // Check all link fields that link foreign datasheets
    for (const fieldId of linkFieldIds) {
        const { foreignDatasheetId, brotherFieldId } = fieldMap[fieldId].property;
        const { snapshot: { recordMap: foreignRecordMap }, } = (0, selectors_1.getDatasheet)(state, foreignDatasheetId);
        // check recordIds that are missing in link cells in foreign datasheet
        for (const recordId in recordMap) {
            const record = recordMap[recordId];
            const cellValue = record.data[fieldId];
            if (!Array.isArray(cellValue)) {
                continue;
            }
            for (const linkedRecordId of cellValue) {
                const foreignRecord = foreignRecordMap[linkedRecordId];
                if (!foreignRecord) {
                    addRedundantRecordId(mainDstId, recordId, fieldId, linkedRecordId);
                }
                else if (!((_c = foreignRecord.data[brotherFieldId]) === null || _c === void 0 ? void 0 : _c.includes(recordId))) {
                    addMissingRecordId(foreignDatasheetId, linkedRecordId, brotherFieldId, recordId);
                }
            }
        }
        // check recordIds that are missing in link cells in main datasheet
        for (const foreignRecordId in foreignRecordMap) {
            const foreignRecord = foreignRecordMap[foreignRecordId];
            const foreignCellValue = foreignRecord.data[brotherFieldId];
            if (!Array.isArray(foreignCellValue)) {
                continue;
            }
            for (const recordId of foreignCellValue) {
                const record = recordMap[recordId];
                if (!record) {
                    addRedundantRecordId(foreignDatasheetId, foreignRecordId, brotherFieldId, recordId);
                }
                else if (!((_d = record.data[fieldId]) === null || _d === void 0 ? void 0 : _d.includes(foreignRecordId))) {
                    addMissingRecordId(mainDstId, recordId, fieldId, foreignRecordId);
                }
            }
        }
    }
    return errorRecordIds.size ? { mainDstId, mainDstName, errorRecordIds } : undefined;
}
exports.checkLinkConsistency = checkLinkConsistency;
function generateFixLinkConsistencyChangesets(error, state) {
    var _a;
    const resourceOps = [];
    for (const [dstId, cells] of error.errorRecordIds) {
        const datasheet = store_1.Selectors.getDatasheet(state, dstId);
        if (!datasheet) {
            continue;
        }
        const { snapshot: { recordMap }, } = datasheet;
        const actions = [];
        for (const [cellId, changes] of cells) {
            const [recordId, fieldId] = cellId.split(':', 2);
            const { missing, redundant } = changes;
            const record = recordMap[recordId];
            if (!record) {
                continue;
            }
            const oldRecordIds = (_a = record.data[fieldId]) !== null && _a !== void 0 ? _a : [];
            let newRecordIds = oldRecordIds;
            if (redundant) {
                newRecordIds = newRecordIds.filter(newRecordIds => !redundant.has(newRecordIds));
            }
            if (missing) {
                newRecordIds = [...newRecordIds, ...missing];
            }
            if (oldRecordIds.length && newRecordIds.length) {
                actions.push({
                    n: engine_1.OTActionName.ObjectReplace,
                    od: oldRecordIds,
                    oi: newRecordIds,
                    p: ['recordMap', recordId, 'data', fieldId],
                });
            }
            else if (oldRecordIds.length) {
                actions.push({
                    n: engine_1.OTActionName.ObjectDelete,
                    od: oldRecordIds,
                    p: ['recordMap', recordId, 'data', fieldId],
                });
            }
            else if (newRecordIds.length) {
                actions.push({
                    n: engine_1.OTActionName.ObjectInsert,
                    oi: newRecordIds,
                    p: ['recordMap', recordId, 'data', fieldId],
                });
            }
        }
        if (actions.length) {
            resourceOps.push({
                resourceId: dstId,
                resourceType: types_1.ResourceType.Datasheet,
                operations: [
                    {
                        cmd: commands_1.CollaCommandName.FixConsistency,
                        actions,
                    },
                ],
            });
        }
    }
    return resourceOps;
}
exports.generateFixLinkConsistencyChangesets = generateFixLinkConsistencyChangesets;
//# sourceMappingURL=link_consistency.js.map